const DEV = process.env.NODE_ENV === 'development';

import jQuery from 'jquery';
import emergence from 'emergence.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('init home');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.log('finalize home');
  },
};
